function InfoBoxWidget() {
  const infoList = [
    {
      lable: process.env.REACT_APP_JOB_PORTAL_ADDRESS,
      icon: "fa-map-marker-alt",
      delay: "0.1s",
    },
    {
      lable: process.env.REACT_APP_JOB_PORTAL_EMAIL,
      icon: "fa-envelope-open",
      delay: "0.3s",
    },
    {
      lable: process.env.REACT_APP_JOB_PORTAL_CONTACT_NUM,
      icon: "fa-phone-alt",
      delay: "0.5s",
    },
  ];

  return (
    <>
      {infoList.map((val, index) => (
        <div
          className="col-md-4 wow fadeIn"
          data-wow-delay={val.delay}
          key={index}
        >
          <div className="d-flex align-items-center bg-light rounded p-4">
            <div
              className="bg-white border rounded d-flex flex-shrink-0 align-items-center justify-content-center me-3"
              style={style.column}
            >
              <i className={`fa ${val.icon} text-primary`}></i>
            </div>
            <span>{val.lable}</span>
          </div>
        </div>
      ))}
    </>
  );
}

const style = {
  column: { width: "45px", height: "45px" },
};

export default InfoBoxWidget;
